import React, {memo} from 'react';
import {TouchableOpacity} from 'react-native';
import {createUseStyle} from '@redlink/assets/styles';
import {
    Text,
    Space,
    IconRadioChecked,
    IconRadioUnchecked,
} from '@redlink/components/atoms';

export const RadioButton = memo(
    ({
         style,
         selected,
         title,
         onPress,
         iconSize,
         iconCheckedColor,
         iconEmptyColor,
         ...rest
     }) => {
        const {styles} = useStyle();
        return (
            <TouchableOpacity
                activeOpacity={0.7}
                style={[styles.radioContainer, style]}
                onPress={onPress}
                {...rest}
            >
                {selected || selected === 0 ? (
                    <IconRadioChecked size={iconSize} color={iconCheckedColor}/>
                ) : (
                    <IconRadioUnchecked size={iconSize} color={iconEmptyColor}/>
                )}
                {title && (
                    <>
                        <Space size={4}/>
                        <Text style={[styles.title, selected && styles.selected]}>
                            {title}
                        </Text>
                    </>
                )}
            </TouchableOpacity>
        );
    }
);

const useStyle = createUseStyle(({colors}) => ({
    radioContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    title: {
        fontSize: 14,
        color: colors.black,
        marginBottom: 3,
    },
    selected: {
        color: colors.blue1,
    },
}));
